import type { PublicationModel, SchedulingSession } from "./types";
import { pubKey } from "./distribute";

export const publicationPinKey = (videoId: string, publicationId: string) => `${videoId}:post:${publicationId}`;

export function hasPublicationPin(
  session: Pick<SchedulingSession, "customDatetimeKeys">, videoId: string, publication: PublicationModel,
) {
  return session.customDatetimeKeys.has(publicationPinKey(videoId, publication.id)) ||
    session.customDatetimeKeys.has(pubKey(videoId, publication.accountId));
}
